import {
  _LOGIN_SUCCESS,
  _LOGIN_FAILED,
  _LOGOUT,
  _GET_SHOP_CREDIT,
  _UPDATE_USER_DATA,
  _LOGIN_MODAL,
} from "./AuthAction";

const _INITIAL_STATE = {
  userData: {},
  heartBeat: false,
  loginMessage: "",
  loginStateInitialized: false,
  creditLimit: 0,
  isToggleLoginModal: false,
};

/// <summary>
/// Author :
/// </summary>
export default (state = _INITIAL_STATE, action) => {
  switch (action.type) {
    case _LOGIN_SUCCESS:
      return {
        ...state,
        userData: action.userData,
        heartBeat: true,
        loginMessage: "",
        loginStateInitialized: true,
        isToggleLoginModal: false,
      };
      break;
    case _LOGIN_FAILED:
      return {
        loginMessage: action.message,
        heartBeat: false,
        userData: {},
        loginStateInitialized: true,
        isToggleLoginModal: false,
      };
      break;
    case _UPDATE_USER_DATA:
      return {
        ...state,
        userData: action.userData,
      };
      break;
    case _GET_SHOP_CREDIT:
      return {
        ...state,
        creditLimit: action.creditLimit,
      };
      break;
    case _LOGOUT:
      return {
        userData: {},
        heartBeat: false,
        loginMessage: "",
        loginStateInitialized: true,
        creditLimit: 0,
        isToggleLoginModal: state.isToggleLoginModal,
      };
      break;
    case _LOGIN_MODAL:
      return {
        ...state,
        isToggleLoginModal: action.isToggleLoginModal,
      };
      break;
    default:
      return state;
      break;
  }
};
